import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import CONFIG from "../../../config.json";
export const GET_LIST_SERVICE = 'GET_LIST_SERVICE'
export const ADD_ITEM_SERVICE = 'ADD_ITEM_SERVICE'
export const DELETE_ITEM_SERVICE = 'DELETE_ITEM_SERVICE'
export const UPDATE_ITEM_SERVICE = 'UPDATE_ITEM_SERVICE'
export const getData = () => (dispatch) => {
    axios.get(CONFIG.SERVER_URL + 'service').then((res) => {
        dispatch({
            type: GET_LIST_SERVICE,
            payload: JSON.parse(res.data.data),
        })
    })

}

export const addData = (data) => (dispatch) => {
    const formData = new FormData();

    // Update the formData object 
    console.log('getData', data)

    if (data.file) {
        formData.append(
            "file",
            data.file,
            data.file.name,
        );
    }
    formData.append(
        "title",
        data.title
    );
    formData.append(
        "meta_title",
        data.meta_title
    );
    formData.append(
        "meta_keyword",
        data.meta_keyword
    );
    formData.append(
        "meta_desc",
        data.meta_desc
    );
    formData.append(
        "description",
        data.description
    );
    if (data.parent) {
        formData.append(
            "parent",
            data.parent
        );
    }
    formData.append(
        "home",
        data.home
    );
    formData.append(
        "status",
        data.status
    );
    formData.append(
        "ordering",
        data.ordering
    );
    formData.append(
        "alt_tag",
        data.alt_tag
    );
    
    axios.post(CONFIG.SERVER_URL + 'service/add', formData).then((res) => {
        if (res.data.status == true) {
            toast.success(res.data.msg);
        } else {
            toast.error(res.data.msg);
        }
        dispatch({
            type: ADD_ITEM_SERVICE,
            payload: res.data.data,
        })
    }).catch((error) => {
        toast.error("Something went wrong");
    })
}

export const deleteData = (id) => (dispatch) => {

    axios.post(CONFIG.SERVER_URL + 'service/delete/' + id).then((res) => {

        if (res.data.status == true) {
            toast.success(res.data.msg);
        } else {
            toast.error(res.data.msg);
        }
        // axios.post(CONFIG.SERVER_URL+'leadership/delete/1000').then((res) => {
        dispatch({
            type: DELETE_ITEM_SERVICE,
            payload: res.data,
            id
        })
    }).catch((error) => {
        toast.error("Something went wrong");
    })
}
export const updateData = (data, id) => (dispatch) => {
    const formData = new FormData();

    // Update the formData object 
    if (data.file) {
        formData.append(
            "file",
            data.file,
            data.file.name,
        );
    }
    formData.append(
        "title",
        data.title
    );
    formData.append(
        "meta_title",
        data.meta_title
    );
    formData.append(
        "meta_keyword",
        data.meta_keyword
    );
    formData.append(
        "meta_desc",
        data.meta_desc
    );
    formData.append(
        "description",
        data.description
    );
    if (data.parent) {
        formData.append(
            "parent",
            data.parent
        );
    }
    formData.append(
        "home",
        data.home
    );
    formData.append(
        "status",
        data.status
    );
    formData.append(
        "ordering",
        data.ordering
    );
    formData.append(
        "alt_tag",
        data.alt_tag
    );
    axios.post(CONFIG.SERVER_URL + 'service/update/' + id, formData).then((res) => {
        if (res.data.status == true) {
            toast.success(res.data.msg);
        } else {
            toast.error(res.data.msg);
        }
        // axios.post(CONFIG.SERVER_URL+'leadership/delete/1000').then((res) => {
        dispatch({
            type: UPDATE_ITEM_SERVICE,
            payload: res.data.data,
            id
        })
    }).catch((error) => {
        toast.error("Something went wrong");
    })
}
